export default __webpack_public_path__ + "static/media/icon_wrench.d6390a3a.png";